import React from 'react';
import Parser from 'html-react-parser';

const PrivacyPolicy = () => {

    const wordContent = `
<p class=MsoNormal align=center style='text-align:center'><b><span lang=EN-US
style='font-size:20.0pt;font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>PRIVACY
POLICY<o:p></o:p></span></b></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Effective Date: April
2025<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Welcome to the
Privacy Policy for att app (collectively “we”, “us” or “our”). We offer att app
software, mobile applications, web sites (together “Services”). This Privacy
Policy explains how we collect, use, disclose, and safeguard your information
when you use our Services.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><b><span lang=EN-US
style='font-size:14.0pt;font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>DATA
WE COLLECT<o:p></o:p></span></b></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>We collect
personal data in different ways when you sign up for or use our Services. The
following is a list of the categories of personal data we collect, and how we
obtain it.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><a name="OLE_LINK1"><b><i><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Personal
Data You Provide<o:p></o:p></span></i></b></a></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK1'><b><i><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></i></b></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK1'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>We
collect personal information that you provide us directly when using our app.
This data is collected to provide you with our Services like account creation,
user identification and logging in. Personal data includes but is not limited
to email address, username, name, surname, password and financial information
if you make any purchases.<o:p></o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK1'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>We
collect your relationship with other users to monetize visibility of your
content. Examples include the friends you add or delete.<o:p></o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK1'><b><i><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></i></b></span></p>

<span style='mso-bookmark:OLE_LINK1'></span>

<p class=MsoNormal style='text-align:justify'><a name="OLE_LINK3"><b><i><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Content
You Provide<o:p></o:p></span></i></b></a></p>

<span style='mso-bookmark:OLE_LINK3'></span>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>We collect the
content you upload or share <span class=GramE>through the use of</span> our
Services. This includes but is not limited to files, photos, videos, audio,
messages, texts, titles, information.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>The files you
share through the app are stored temporarily on our servers to facilitate
sharing with other users within your specified location. These files are
automatically deleted after a set period. We do not access or use the
information in the files and documents that you upload when you use our
Services, except for the limited occasions where we are required to do so by
law or in response to valid requests by public authorities.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>We collect
location information associated to each content to enable sharing files on
locations as this is a core feature of our Services.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><a name="OLE_LINK4"><b><i><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Data
We Collect When You Use Our Services<o:p></o:p></span></i></b></a></p>

<span style='mso-bookmark:OLE_LINK4'></span>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>We collect
technical information including but not limited to IP address, OS of the
device, device model, approximate geolocation when you use our services. We
assign a unique user identification for each user who is registered to use our <a
name="OLE_LINK2">Services</a>.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>We collect
information about the content you provide including the size, visibility
(option for choosing which users will be able to see your content) and duration
(option for determining the time to pass before deletion) of your uploaded
content, number of your uploaded contents when you user our Services. <o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>We collect your
location data to enable the file-sharing functionality. This data is used to
enable sharing at the location. Location data associated with shared files is
stored temporarily to facilitate the file-sharing process and is deleted along
with the files after the specified period. You may not give access to location
services and still use our Services by determining the location manually from
the map interface.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>We collect
payment and purchase information when you make purchases through our Services
including but not limited to purchased items, transaction ID &amp; data, price.
<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><a name="OLE_LINK5"><b><i><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Data
Received from Other Services<o:p></o:p></span></i></b></a></p>

<span style='mso-bookmark:OLE_LINK5'></span>

<p class=MsoNormal style='text-align:justify'><b><i><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></i></b></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>We receive
technical information and purchase information from Payment and Transaction Fulfillment
Providers when you make purchases through our Services.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>We receive
information about usage data including how much our Services are used from our
measurement partners.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><a name="OLE_LINK15"><b><span
lang=EN-US style='font-size:14.0pt;font-family:"Arial",sans-serif;mso-ansi-language:
EN-US'>HOW AND </span></b></a><span class=GramE><span style='mso-bookmark:OLE_LINK15'><b><span
lang=EN-US style='font-size:14.0pt;font-family:"Arial",sans-serif;mso-ansi-language:
EN-US'>WHY</span></b></span></span><span style='mso-bookmark:OLE_LINK15'><b><span
lang=EN-US style='font-size:14.0pt;font-family:"Arial",sans-serif;mso-ansi-language:
EN-US'> WE USE INFORMATION<o:p></o:p></span></b></span></p>

<span style='mso-bookmark:OLE_LINK15'></span>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>We utilize
personal information, including your email address, username, name, and
surname, to identify users, create accounts, and manage social features such as
adding and removing friends.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Account login
details, including passwords, are used to authenticate users and ensure secure
access to our platform.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Financial
information, as well as purchase and transaction details, is processed to
facilitate the delivery of our Services, including paid offerings.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Information
related to uploaded content, such as location, duration, and visibility
settings, is employed to enable and enhance the core features of our Services.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><b><span lang=EN-US
style='font-size:14.0pt;font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>DATA
RETENTION<o:p></o:p></span></b></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>We retain the
personal data you provide for as long as your account remains active or as
necessary to deliver our services to you.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>User-generated
content, categorized under &quot;Content You Provide,&quot; is stored according
to the duration specified in the &quot;Visibility&quot; property of the upload.
Following deletion, this content may remain temporarily on our servers for up to
one hour before permanent removal.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>We perform
regular backups of our servers to ensure data integrity and availability. These
backups may include personal data and are stored securely in accordance with
our data retention and security policies. Personal data in backups is retained
only for as long as necessary for these purposes and is protected against
unauthorized access. Deleted content may take up to 15 additional days to be
fully removed from our backup and disaster recovery systems. During this
period, the data is retained solely to maintain system integrity and is not
actively used.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>As we
collaborate with third-party service providers, they operate under their own
policies. For further details, please refer to the section titled &quot;When
and Why We Share Your Data with Others.&quot;<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><b><span lang=EN-US
style='font-size:14.0pt;font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>WHEN
AND <span class=GramE>WHY</span> WE SHARE YOUR DATA WITH OTHERS<o:p></o:p></span></b></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>We share data
with others to offer our Services to you. The data &amp; reasons for sharing
are explained below.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify'><span lang=EN-US
style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>

<div align=center>

<table class=MsoTableGrid border=1 cellspacing=0 cellpadding=0
 style='border-collapse:collapse;border:none;mso-border-alt:solid windowtext .5pt;
 mso-yfti-tbllook:1184;mso-padding-alt:0cm 5.4pt 0cm 5.4pt'>
 <tr style='mso-yfti-irow:0;mso-yfti-firstrow:yes;height:169.1pt'>
  <td width=604 valign=top style='width:453.1pt;border:solid windowtext 1.0pt;
  mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt;height:169.1pt'>
  <p class=MsoNormal style='text-align:justify'><a name="OLE_LINK8"></a><a
  name="OLE_LINK10"></a><a name="OLE_LINK6"><span style='mso-bookmark:OLE_LINK10'><span
  style='mso-bookmark:OLE_LINK8'><b><span lang=EN-US style='font-family:"Arial",sans-serif;
  mso-ansi-language:EN-US'>Data Shared</span></b></span></span></a><span
  style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'><b><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>:</span></b></span></span><span
  style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>
  Any of the data described under Personal Data You Provide, Content You
  Provide, Data We Collect When You Use Our Services, Data Received from Other
  Services<o:p></o:p></span></span></span></p>
  <p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK10'><span
  style='mso-bookmark:OLE_LINK8'><b><span lang=EN-US style='font-family:"Arial",sans-serif;
  mso-ansi-language:EN-US'>Recipients: </span></b></span></span><span
  style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Service
  providers such as cloud hosting, data storage, delivery &amp; security<o:p></o:p></span></span></span></p>
  <p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK10'><span
  style='mso-bookmark:OLE_LINK8'><b><span lang=EN-US style='font-family:"Arial",sans-serif;
  mso-ansi-language:EN-US'>Reason: </span></b></span></span><span
  style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'><span
  class=GramE><span lang=EN-US style='font-family:"Arial",sans-serif;
  mso-ansi-language:EN-US'>In order to</span></span></span></span><span
  style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>
  provide our Services to you, we must depend on various service providers to
  facilitate and support our activities. Please be aware that the Application
  relies on third-party services, each of which has its own Privacy Policy
  regarding data handling. You can find links to the Privacy Policies of these
  third-party service providers below:<o:p></o:p></span></span></span></p>
  <p class=MsoListParagraphCxSpFirst style='text-align:justify;text-indent:
  -18.0pt;mso-list:l0 level1 lfo4'><span style='mso-bookmark:OLE_LINK10'><span
  style='mso-bookmark:OLE_LINK8'><![if !supportLists]><span lang=EN-US
  style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
  mso-ansi-language:EN-US'><span style='mso-list:Ignore'>-<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><span
  dir=LTR></span><span lang=EN-US style='font-family:"Arial",sans-serif;
  mso-ansi-language:EN-US'>Google Play Services </span></span></span><a className="text-blue-700"
  href="https://policies.google.com/privacy"><span style='mso-bookmark:OLE_LINK10'><span
  style='mso-bookmark:OLE_LINK8'><span lang=EN-US style='font-family:"Arial",sans-serif;
  mso-ansi-language:EN-US'>https://policies.google.com/privacy</span></span></span><span
  style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'></span></span></a><span
  style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p></o:p></span></span></span></p>
  <p class=MsoListParagraphCxSpMiddle style='text-align:justify;text-indent:
  -18.0pt;mso-list:l0 level1 lfo4'><span style='mso-bookmark:OLE_LINK10'><span
  style='mso-bookmark:OLE_LINK8'><![if !supportLists]><span lang=EN-US
  style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
  mso-ansi-language:EN-US'><span style='mso-list:Ignore'>-<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><span
  dir=LTR></span><span lang=EN-US style='font-family:"Arial",sans-serif;
  mso-ansi-language:EN-US'>Expo </span></span></span><a className="text-blue-700"
  href="https://expo.dev/privacy"><span style='mso-bookmark:OLE_LINK10'><span
  style='mso-bookmark:OLE_LINK8'><span lang=EN-US style='font-family:"Arial",sans-serif;
  mso-ansi-language:EN-US'>https://expo.dev/privacy</span></span></span><span
  style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'></span></span></a><span
  style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p></o:p></span></span></span></p>
  <p class=MsoListParagraphCxSpMiddle style='text-align:justify;text-indent:
  -18.0pt;mso-list:l0 level1 lfo4'><span style='mso-bookmark:OLE_LINK10'><span
  style='mso-bookmark:OLE_LINK8'><![if !supportLists]><span lang=EN-US
  style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
  mso-ansi-language:EN-US'><span style='mso-list:Ignore'>-<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><span
  dir=LTR></span><span class=SpellE><span lang=EN-US style='font-family:"Arial",sans-serif;
  mso-ansi-language:EN-US'>RevenueCat</span></span></span></span><span
  style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'> </span></span></span><a className="text-blue-700"
  href="https://www.revenuecat.com/privacy/"><span style='mso-bookmark:OLE_LINK10'><span
  style='mso-bookmark:OLE_LINK8'><span lang=EN-US style='font-family:"Arial",sans-serif;
  mso-ansi-language:EN-US'>https://www.revenuecat.com/privacy/</span></span></span><span
  style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'></span></span></a><span
  style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p></o:p></span></span></span></p>
  <p class=MsoListParagraphCxSpMiddle style='text-align:justify;text-indent:
  -18.0pt;mso-list:l0 level1 lfo4'><span style='mso-bookmark:OLE_LINK10'><span
  style='mso-bookmark:OLE_LINK8'><![if !supportLists]><span lang=EN-US
  style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
  mso-ansi-language:EN-US'><span style='mso-list:Ignore'>-<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><span
  dir=LTR></span><span lang=EN-US style='font-family:"Arial",sans-serif;
  mso-ansi-language:EN-US'>Google Firebase </span></span></span><a className="text-blue-700"
  href="https://firebase.google.com/support/privacy"><span style='mso-bookmark:
  OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'><span lang=EN-US
  style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>https://firebase.google.com/support/privacy</span></span></span><span
  style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'></span></span></a><span
  style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p></o:p></span></span></span></p>
  <p class=MsoListParagraphCxSpMiddle style='text-align:justify;text-indent:
  -18.0pt;mso-list:l0 level1 lfo4'><span style='mso-bookmark:OLE_LINK10'><span
  style='mso-bookmark:OLE_LINK8'><![if !supportLists]><span lang=EN-US
  style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
  mso-ansi-language:EN-US'><span style='mso-list:Ignore'>-<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><span
  dir=LTR></span><span lang=EN-US style='font-family:"Arial",sans-serif;
  mso-ansi-language:EN-US'>Google Cloud Platform </span></span></span><a className="text-blue-700"
  href="https://cloud.google.com/terms/cloud-privacy-notice"><span
  style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>https://cloud.google.com/terms/cloud-privacy-notice</span></span></span><span
  style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'></span></span></a><span
  style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p></o:p></span></span></span></p>
  <span style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'></span></span>
  <p class=MsoListParagraphCxSpLast style='text-align:justify'><span
  style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></span></span></p>
  </td>
  <span style='mso-bookmark:OLE_LINK10'><span style='mso-bookmark:OLE_LINK8'></span></span>
 </tr>
 <tr style='mso-yfti-irow:1'>
  <td width=604 valign=top style='width:453.1pt;border:solid windowtext 1.0pt;
  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  padding:0cm 5.4pt 0cm 5.4pt'><span style='mso-bookmark:OLE_LINK8'></span>
  <p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></span></p>
  </td>
  <span style='mso-bookmark:OLE_LINK8'></span>
 </tr>
 <tr style='mso-yfti-irow:2;height:83.8pt'>
  <td width=604 valign=top style='width:453.1pt;border:solid windowtext 1.0pt;
  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:83.8pt'>
  <p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK8'><b><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Data
  Shared:</span></b></span><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>
  Personal information, financial <a name="OLE_LINK9">information </a>&amp;
  purchase data described under Personal Data You Provide, Data We Collect When
  You Use Our Services, Data Received from Other Services<o:p></o:p></span></span></p>
  <p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK8'><b><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Recipients:
  </span></b></span><span style='mso-bookmark:OLE_LINK8'><span lang=EN-US
  style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Payment &amp;
  Transaction Fulfillment Service Providers<o:p></o:p></span></span></p>
  <p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK8'><b><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Reason:
  </span></b></span><span style='mso-bookmark:OLE_LINK8'><span class=GramE><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>In
  order to</span></span></span><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>
  provide paid services, we share information with service providers when you
  make any purchase.<o:p></o:p></span></span></p>
  </td>
  <span style='mso-bookmark:OLE_LINK8'></span>
 </tr>
 <tr style='mso-yfti-irow:3'>
  <td width=604 valign=top style='width:453.1pt;border:solid windowtext 1.0pt;
  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  padding:0cm 5.4pt 0cm 5.4pt'><span style='mso-bookmark:OLE_LINK8'></span>
  <p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></span></p>
  </td>
  <span style='mso-bookmark:OLE_LINK8'></span>
 </tr>
 <tr style='mso-yfti-irow:4;height:83.8pt'>
  <td width=604 valign=top style='width:453.1pt;border:solid windowtext 1.0pt;
  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:83.8pt'>
  <p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK8'><a
  name="OLE_LINK13"><b><span lang=EN-US style='font-family:"Arial",sans-serif;
  mso-ansi-language:EN-US'>Data Shared:</span></b></a></span><span
  style='mso-bookmark:OLE_LINK8'><span style='mso-bookmark:OLE_LINK13'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>
  Any of the data described under Personal Data You Provide, Content You <a
  name="OLE_LINK12">Provide, Data We Collect When You Use Our Services, Data
  Received from Other Services<o:p></o:p></a></span></span></span></p>
  <p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK8'><span
  style='mso-bookmark:OLE_LINK13'><span style='mso-bookmark:OLE_LINK12'><b><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Recipients:
  </span></b></span></span></span><span style='mso-bookmark:OLE_LINK8'><span
  style='mso-bookmark:OLE_LINK13'><span style='mso-bookmark:OLE_LINK12'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Law
  enforcements &amp; public authorities<o:p></o:p></span></span></span></span></p>
  <p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK8'><span
  style='mso-bookmark:OLE_LINK13'><span style='mso-bookmark:OLE_LINK12'><b><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Reason:
  </span></b></span></span></span><span style='mso-bookmark:OLE_LINK8'><span
  style='mso-bookmark:OLE_LINK13'><span style='mso-bookmark:OLE_LINK12'><span
  class=GramE><span lang=EN-US style='font-family:"Arial",sans-serif;
  mso-ansi-language:EN-US'>In order to</span></span></span></span></span><span
  style='mso-bookmark:OLE_LINK8'><span style='mso-bookmark:OLE_LINK13'><span
  style='mso-bookmark:OLE_LINK12'><span lang=EN-US style='font-family:"Arial",sans-serif;
  mso-ansi-language:EN-US'> comply with applicable laws, government requests or
  to protect the rights &amp; safety of other users or to detect infringement
  &amp; illegal activities or to investigate violation of our terms; we may
  access, keep &amp; share your information.<o:p></o:p></span></span></span></span></p>
  </td>
  <span style='mso-bookmark:OLE_LINK8'><span style='mso-bookmark:OLE_LINK13'><span
  style='mso-bookmark:OLE_LINK12'></span></span></span>
 </tr>
 <tr style='mso-yfti-irow:5'>
  <td width=604 valign=top style='width:453.1pt;border:solid windowtext 1.0pt;
  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  padding:0cm 5.4pt 0cm 5.4pt'><span style='mso-bookmark:OLE_LINK8'></span>
  <p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></span></p>
  </td>
  <span style='mso-bookmark:OLE_LINK8'></span>
 </tr>
 <tr style='mso-yfti-irow:6;mso-yfti-lastrow:yes;height:126.7pt'>
  <td width=604 valign=top style='width:453.1pt;border:solid windowtext 1.0pt;
  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:126.7pt'>
  <p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK8'><b><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Data
  Shared:</span></b></span><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'> Username,
  Name, Surname, Email under Personal Data You Provide<o:p></o:p></span></span></p>
  <p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Content
  Name, Duration, Visibility, Location, Files &amp; Documents under Content You
  Provide<o:p></o:p></span></span></p>
  <p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Content
  Size under Data We Collect When You Use Our Services<o:p></o:p></span></span></p>
  <p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK8'><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Purchase
  Information under Data Received <span class=GramE>From</span> Other Services<o:p></o:p></span></span></p>
  <p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK8'><b><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Recipients:
  </span></b></span><span style='mso-bookmark:OLE_LINK8'><span lang=EN-US
  style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Other Users<o:p></o:p></span></span></p>
  <p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK8'><b><span
  lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Reason:
  </span></b></span><span style='mso-bookmark:OLE_LINK8'><span lang=EN-US
  style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>To ensure our
  Services properly, we share some of your information with other users when
  you upload content or interact with other users. This includes the content
  you upload, your personal information and purchased product information.<o:p></o:p></span></span></p>
  </td>
  <span style='mso-bookmark:OLE_LINK8'></span>
 </tr>
</table>

</div>

<span style='mso-bookmark:OLE_LINK8'></span>

<p class=MsoNormal style='text-align:justify'><a name="OLE_LINK7"><b><span
lang=EN-US style='font-size:16.0pt;font-family:"Arial",sans-serif;mso-ansi-language:
EN-US'><o:p>&nbsp;</o:p></span></b></a></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><b><span
lang=EN-US style='font-size:14.0pt;font-family:"Arial",sans-serif;mso-ansi-language:
EN-US'>SECURITY</span></b></span><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-size:11.0pt;font-family:"Arial",sans-serif;mso-ansi-language:
EN-US'><o:p></o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>We
are committed to safeguarding the confidentiality of your information. We
implement physical and electronic safeguards to protect the information we
process and maintain. For instance, access to this information is restricted to
authorized employees and contractors who require it to operate, develop, or
enhance the Application. Moreover, we ensure that personal information is
accessible only to individuals who need it to perform their duties and are
properly authorized. <o:p></o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>Please
note that while we strive to provide robust security for the information we
process and maintain, no security system can guarantee complete protection
against all potential security breaches.<o:p></o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><b><span
lang=EN-US style='font-size:14.0pt;font-family:"Arial",sans-serif;mso-ansi-language:
EN-US'>YOUR RIGHTS<o:p></o:p></span></b></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>You
are granted several key rights to ensure greater control over your personal
data. These include your right to access your data and understand how it is
processed, as well as the right to rectify any inaccuracies or incomplete
information. You can also request the erasure of your data (right to be
forgotten) or restrict its processing under certain conditions. Additionally,
you have the right to data portability, enabling you to receive your personal
data in a commonly used format and transfer it to another controller. You may
withdraw your consent at any time if it serves as the basis for processing and
can lodge complaints to us if you believe your rights have been violated.
Finally, you have the right to be informed about how your data is collected,
used, and shared, ensuring transparency in data handling practices.<o:p></o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><b><span
lang=EN-US style='font-size:14.0pt;font-family:"Arial",sans-serif;mso-ansi-language:
EN-US'>CHILDREN<o:p></o:p></span></b></span></p>

<p style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-family:"Arial",sans-serif;color:black;mso-ansi-language:
EN-US'>Our Services are not intended for children and may only be used by
individuals who are 16 years of age or older.<o:p></o:p></span></span></p>
<p className="mt-5"></p>
<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><b><span
lang=EN-US style='font-size:14.0pt;font-family:"Arial",sans-serif;mso-ansi-language:
EN-US'>CHANGES TO THIS PRIVACY POLICY<o:p></o:p></span></b></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>We
may update this Privacy Policy from time to time. We will notify you of any
changes by posting the new Privacy Policy in the app. You are advised to review
this Privacy Policy periodically for any changes.<o:p></o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><b><span
lang=EN-US style='font-size:14.0pt;font-family:"Arial",sans-serif;mso-ansi-language:
EN-US'>CONTACT US<o:p></o:p></span></b></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>If
you have any questions or requests, contact us at <o:p></o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>legal@att-app.com
<o:p></o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>or at
physical address: PK/15 <span class=SpellE>Şişli</span> PTT <span class=SpellE>Şişli</span>
/ Türkiye<o:p></o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></span></p>

<p class=MsoNormal style='text-align:justify'><span style='mso-bookmark:OLE_LINK7'><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'>By
using att app, you consent to the terms of this Privacy Policy.</span></span><span
lang=EN-US style='font-family:"Arial",sans-serif;mso-ansi-language:EN-US'><o:p></o:p></span></p>

`


    return (
        <div className='lg:w-1/2 text-sm mt-5 p-2 text-center'>
            {Parser(wordContent)}
        </div>
    );
};

export default PrivacyPolicy;